import { useDeviceDetect } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';
import { ExplanationTypeEnum } from '@doltech/utils/lib/constants';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ParaphrasingViewOnlyComponent } from '../../../paraphrasing/ParaphrasingViewOnly';
import { CorrectAnswerInstance } from '../../../question-data-model/Question/CorrectOption/_extends/correct-answer.store';
import {
  ExplanationSummaryAndDetailProps,
  Main,
  ParaphrasingWrapper,
} from './SingleChoiceExplanationSummaryAndDetail';
import { getInitValue, getTitle } from './util';

interface BlankChoiceExplanationSummaryAndDetailProps extends ExplanationSummaryAndDetailProps {
  correctAnswers: CorrectAnswerInstance[];
  correction: any;
  qIndex: number;
  showTitle?: boolean;
}

export const BlankChoiceExplanationSummaryAndDetail = observer(
  (props: BlankChoiceExplanationSummaryAndDetailProps) => {
    const { qIndex, correctAnswers, showTitle } = props;
    const { isMobile } = useDeviceDetect();
    const currentCorrectAnswer = (correctAnswers || []).find((_, index) => index === qIndex);

    return (
      <Main>
        <ParaphrasingWrapper>
          {ExplanationTypeEnum.LISTENING_EXPLANATION !== currentCorrectAnswer?.explanation?.type &&
            currentCorrectAnswer?.explanation?.locatedPassage && (
              <ParaphrasingViewOnlyComponent
                className="explanation-detail-section"
                title={getTitle(currentCorrectAnswer?.explanation)}
                initValue={getInitValue(currentCorrectAnswer?.explanation)}
                showTitle={showTitle}
              />
            )}
        </ParaphrasingWrapper>

        {isMobile && currentCorrectAnswer?.explanation?.locatedPassage && (
          <ParaphrasingWrapper>
            <ParaphrasingViewOnlyComponent
              className="explanation-detail-section"
              title="Located Paragraph"
              initValue={currentCorrectAnswer?.explanation?.locatedPassage}
              showTitle={showTitle}
            />
          </ParaphrasingWrapper>
        )}

        <ParaphrasingWrapper>
          <ParaphrasingViewOnlyComponent
            className="explanation-detail-section"
            title="Giải thích chi tiết"
            initValue={currentCorrectAnswer?.explanation?.detailExplanation}
            showTitle={showTitle}
          />
        </ParaphrasingWrapper>
      </Main>
    );
  }
);
